export default "__VITE_ASSET__DZATn0TL__"